/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationsState } from './MatchOperationsState';
import {
    MatchOperationsStateFromJSON,
    MatchOperationsStateFromJSONTyped,
    MatchOperationsStateToJSON,
    MatchOperationsStateToJSONTyped,
} from './MatchOperationsState';
import type { MatchOperationsEventRejected } from './MatchOperationsEventRejected';
import {
    MatchOperationsEventRejectedFromJSON,
    MatchOperationsEventRejectedFromJSONTyped,
    MatchOperationsEventRejectedToJSON,
    MatchOperationsEventRejectedToJSONTyped,
} from './MatchOperationsEventRejected';
import type { MatchOperationsEvent } from './MatchOperationsEvent';
import {
    MatchOperationsEventFromJSON,
    MatchOperationsEventFromJSONTyped,
    MatchOperationsEventToJSON,
    MatchOperationsEventToJSONTyped,
} from './MatchOperationsEvent';

/**
 * 
 * @export
 * @interface MatchOperationsEventIngestResponse
 */
export interface MatchOperationsEventIngestResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatchOperationsEventIngestResponse
     */
    accepted?: Array<string>;
    /**
     * 
     * @type {Array<MatchOperationsEventRejected>}
     * @memberof MatchOperationsEventIngestResponse
     */
    rejected?: Array<MatchOperationsEventRejected>;
    /**
     * 
     * @type {Array<MatchOperationsEvent>}
     * @memberof MatchOperationsEventIngestResponse
     */
    events?: Array<MatchOperationsEvent>;
    /**
     * 
     * @type {MatchOperationsState}
     * @memberof MatchOperationsEventIngestResponse
     */
    state?: MatchOperationsState;
}

/**
 * Check if a given object implements the MatchOperationsEventIngestResponse interface.
 */
export function instanceOfMatchOperationsEventIngestResponse(value: object): value is MatchOperationsEventIngestResponse {
    return true;
}

export function MatchOperationsEventIngestResponseFromJSON(json: any): MatchOperationsEventIngestResponse {
    return MatchOperationsEventIngestResponseFromJSONTyped(json, false);
}

export function MatchOperationsEventIngestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsEventIngestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accepted': json['accepted'] == null ? undefined : json['accepted'],
        'rejected': json['rejected'] == null ? undefined : ((json['rejected'] as Array<any>).map(MatchOperationsEventRejectedFromJSON)),
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(MatchOperationsEventFromJSON)),
        'state': json['state'] == null ? undefined : MatchOperationsStateFromJSON(json['state']),
    };
}

export function MatchOperationsEventIngestResponseToJSON(json: any): MatchOperationsEventIngestResponse {
    return MatchOperationsEventIngestResponseToJSONTyped(json, false);
}

export function MatchOperationsEventIngestResponseToJSONTyped(value?: MatchOperationsEventIngestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accepted': value['accepted'],
        'rejected': value['rejected'] == null ? undefined : ((value['rejected'] as Array<any>).map(MatchOperationsEventRejectedToJSON)),
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(MatchOperationsEventToJSON)),
        'state': MatchOperationsStateToJSON(value['state']),
    };
}

